import { ReactNode, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { ModalProps } from '@shopify/polaris';
import { useApp } from '@context/app';
import { ModalRef } from '@ui/modal';
import { usePreventRouteChange } from '../router';

const useModal = (): ModalRef => {
  const { getModalRef } = useApp();
  return getModalRef && getModalRef();
};

export type ConfirmModal = {
  title: string;
  description: () => ReactNode;
  onClose?: () => void;
  primaryAction?: ModalProps['primaryAction'];
  secondaryAction?: ModalProps['primaryAction'];
};

export const useRouteConfirmation = ({
  description,
  shouldCheck,
  title,
}: Pick<ConfirmModal, 'description' | 'title'> & { shouldCheck: boolean }) => {
  const [check, setCheck] = useState(shouldCheck);
  const router = useRouter();
  const modal = useModal();

  useEffect(() => {
    setCheck(shouldCheck);
  }, [shouldCheck]);

  usePreventRouteChange(check, (url) => {
    modal.updateContent(description);
    modal.updateProps({
      primaryAction: {
        content: 'Leave page',
        destructive: true,
        onAction: () => {
          router.push(url);
          setCheck(false);
        },
      },
      secondaryAction: {
        content: 'Continue editing',
      },
      title,
    });
    modal.showModal();
  });
};

export default useModal;
